// extracted by mini-css-extract-plugin
export default {"content":"tnP4a1ZtcLiEiUqKKGbe","section":"xP3uVLSl7QegtR5IsbwT","title":"RBUBJTQzFI3JdI9RMvBt"};